import React, { useState, useRef, useEffect } from 'react';

const MealTypeMultiSelect = ({ options = [], value = [], onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleOption = (option) => {
    const normalized = option.toLowerCase();
    if (value.includes(normalized)) {
      onChange(value.filter((item) => item !== normalized));
    } else {
      onChange([...value, normalized]);
    }
  };

  const toggleAll = () => {
    if (value.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map((option) => option.toLowerCase()));
    }
  };

  const getLabel = () => {
    if (value.length === 0) return 'Tipos de comida';
    if (value.length === options.length) return 'Todos seleccionados';
    const formatted = value
      .map((type) => type.charAt(0).toUpperCase() + type.slice(1))
      .join(', ');
    return formatted;
  };

  return (
    <div className={`meal-type-multiselect ${open ? 'open' : ''}`} ref={wrapperRef}>
      <button
        type="button"
        className="multiselect-toggle"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{getLabel()}</span>
        <span className="chevron">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div className="multiselect-panel">
          <label className="multiselect-option select-all">
            <input
              type="checkbox"
              checked={value.length === options.length && options.length > 0}
              onChange={toggleAll}
            />
            Seleccionar todos
          </label>
          <div className="multiselect-divider" />
          {options.map((option) => (
            <label key={option} className="multiselect-option">
              <input
                type="checkbox"
                checked={value.includes(option.toLowerCase())}
                onChange={() => toggleOption(option)}
              />
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default MealTypeMultiSelect;
